import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconGooglePodcastsBrandedStyle0 = cosmosIconCss;

const CosmosIconGooglePodcastsBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGooglePodcastsBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '039352377d29fa3061e6baf24e89a2fc87606cf4', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'c9f319f1d95e39740e176e8ab8a3f0818d3e7561', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '14b8e6a0aa7d3c2f14cbf2db32ffd6550df58a18', d: "M4 9.455a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0v-1.09a1 1 0 0 0-1-1Z", fill: "#0066D9" }), h("path", { key: '1566b59ee50b495a7c80083c992a6a9f7e8cca01', d: "M18 9.455a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0v-1.09a1 1 0 0 0-1-1Z", fill: "#4285F4" }), h("path", { key: 'd441fec1b52523187394873e6d7c7c9aaee0838f', d: "M7.454 12.727a1 1 0 0 0-1 1v1.091a1 1 0 1 0 2 0v-1.09a1 1 0 0 0-1-1Zm0-6.545a1 1 0 0 0-1 1v3.568a1 1 0 0 0 2 0V7.182a1 1 0 0 0-1-1Z", fill: "#EA4335" }), h("path", { key: '880248f8a0b15ffc181db69998cd515a3c30793a', d: "M14.545 6.182a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0v-1.09a1 1 0 0 0-1-1Z", fill: "#34A853" }), h("path", { key: 'c4e4065717a6461d1aeceb39b36e39d972e9ddbc', d: "M11 3a1 1 0 0 0-1 1v1.09a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1Zm0 12.91a1 1 0 0 0-1 1V18a1 1 0 1 0 2 0v-1.09a1 1 0 0 0-1-1Z", fill: "#FAB908" }), h("path", { key: '8dfda0163233192a91f95a9f0ca4581dd9bcfb85', d: "M14.545 10.273a1 1 0 0 0-1 1v3.545a1 1 0 1 0 2 0v-3.545a1 1 0 0 0-1-1Z", fill: "#34A853" }), h("path", { key: '1fdaf64636700624efc6e1621ae9c1ef529a6236', d: "M12 8.09a1 1 0 1 0-2 0v5.82a1 1 0 1 0 2 0V8.09Z", fill: "#FAB908" }))));
    }
    static get style() { return CosmosIconGooglePodcastsBrandedStyle0; }
}, [1, "cosmos-icon-google-podcasts-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-google-podcasts-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-google-podcasts-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGooglePodcastsBranded$1);
            }
            break;
    } });
}

const CosmosIconGooglePodcastsBranded = CosmosIconGooglePodcastsBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGooglePodcastsBranded, defineCustomElement };
